import axios from 'axios'
import mocks from './organization.mock'

export const getGroupsRoute = '/api/rest/org/common/group/permission/ViewOrg'
export const getTeamsRoute = '/api/rest/org/common/team/permission/ViewOrg'
export const getAgentsRoute = '/api/rest/org/common/agents/for/team/0'

export default {
  async getGroups(cancelToken, queryParams = '') {
    const response = await axios.get(`${getGroupsRoute}${queryParams}`, { cancelToken })
    return response.data.map(group => ({ name: group.name, id: String(group.id) }))
  },
  async getTeams(cancelToken, queryParams = '') {
    const response = await axios.get(`${getTeamsRoute}${queryParams}`, { cancelToken })
    return response.data.map(team => ({
      id: String(team.id),
      parentGroupId: String(team.parentGroupId),
      name: team.name,
    }))
  },
  async getAgents(cancelToken, queryParams = '') {
    const response = await axios.get(`${getAgentsRoute}${queryParams}`, { cancelToken, params: { includeInactive: true } })
    return response.data.agents.map(agent => ({
      name: agent.displayId,
      id: String(agent.id),
      acdId: String(agent.acdId),
      teamId: String(agent.groupId),
      isActive: agent.deactivated > Date.now(),
    }))
  },
}

export const mock = {
  getGroups() {
    return mocks.groups.map(group => ({ name: group.name, id: String(group.id) }))
  },
  getTeams() {
    return mocks.teams.map(team => ({
      name: team.name,
      id: String(team.id),
      parentGroupId: String(team.parentGroupId),
    }))
  },
  getAgents() {
    return mocks.agentsForTeam
  },
}
